<template>
    <Input v-model="person.last_name" placeholder="Фамилия" :disabled="disabled" :error="errors?.last_name" />
    <Input v-model="person.first_name" placeholder="Имя" :disabled="disabled" :error="errors?.first_name" />
    <Input v-model="person.middle_name" placeholder="Отчество" :disabled="disabledMiddleName" :error="errors?.middle_name" />

    <input 
        :id="id"
        v-model="person.has_middle_name"
        class="checkbox__input"
        type="checkbox"
        :disabled="disabled"
    >
    <label class="checkbox__label" :for="id">
        <span class="checkbox__label--icon">
            <img class="icon" src="@/create/assets/icons/check.svg" alt="">
        </span>
        <span class="checkbox__label--text">Отчество отсутствует</span>
    </label>

    <div v-if="withDate" class="birthdate">
        <p>Дата рождения</p>
        <Input type="date" v-model="person.birth_date" :disabled="disabled" :error="errors?.birth_date" />
    </div>

    <div v-if="deleter" class="deleter" :class="{'disabled': canBeDeleted}" @click="$emit('delete')" >|</div>
</template>

<script>
import Input from '@/create/components/UI/inputs/Input.vue';

    export default {
        components: {
            Input,
        },
        props: {
            person: Object,
            id: String,
            withDate: Boolean,
            deleter: Boolean,
            disabled: Boolean,
            disabledMiddleName: Boolean,
            canBeDeleted: Boolean,
            errors: Object,
        },
        emits: ['delete'],
    }
</script>

<style lang="scss" scoped>
.birthdate {
    position: relative;

    p {
        position: absolute;
        top: -1.5rem;

        @media (max-width: 480px) {
            position: relative;
            top: 0;
        }
    }
}

.deleter {
    background-color: white;
    border: 1px solid gainsboro;
    border-radius: 50%;
    width: 44.6px;
    height: 44.6px;
    color: gainsboro;
    display: flex;
    align-items: center;
    justify-content: center;
    rotate: 90deg;
    transition: 0.5s;
    cursor: pointer;

    &:hover {
        background-color: #00509f;
    }
}

.disabled {
    background-color: grey;
    pointer-events: none;
}
</style>